export var GET_DEVICE_INFO = 'GET_DEVICE_INFO';
export var getDeviceInfo = function getDeviceInfo() {
  return {
    type: GET_DEVICE_INFO,
    payload: window.navigator.userAgent.indexOf('android-haldor') > -1 || window.navigator.userAgent.indexOf('ios-haldor') > -1 ? true : false
  };
};